"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (attr, fn) {
    document.body.addEventListener('click', function (e) {
        var target = e.target;
        // we have to look up the DOM to handle cases like <a data-whatever><img></a>
        var aTarget = ['A', 'BUTTON'].includes(target.tagName) ? target : target.closest('a');
        if (!aTarget || !aTarget.hasAttribute(attr)) {
            return;
        }
        e.preventDefault();
        fn(aTarget.getAttribute(attr) || '', aTarget);
    });
});
